/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 見えるボタンの色。BRAND=テナントの既定ボタン色 / CUSTOM=customColor を使う
 */
export type HotspotButtonColor = (typeof HotspotButtonColor)[keyof typeof HotspotButtonColor]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HotspotButtonColor = {
  WHITE: 'WHITE',
  BLACK: 'BLACK',
  BLUE: 'BLUE',
  RED: 'RED',
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
  BRAND: 'BRAND',
  CUSTOM: 'CUSTOM',
} as const
